import type { ContourLabel, ContourLabelItemId } from './contour-definitions';

import { defineStore } from 'pinia';

export type ContourChangeType
  = | 'add'
    | 'modify'
    | 'delete'
    | 'deleteAll'
    | 'translate'
    | 'copy'
    | 'batch'
    | 'import';

export interface ContourChangeEvent {
  type: ContourChangeType;
  UIDs: string[];
  label?: ContourLabel;
  id?: ContourLabelItemId;
}

type ContourChangeListener = (event: ContourChangeEvent) => void;

export const useContourEventStore = defineStore('contourEventStore', () => {
  const listeners: ContourChangeListener[] = [];

  function emit(event: ContourChangeEvent) {
    listeners.forEach(cb => cb(event));
  }

  function off(callback: ContourChangeListener) {
    const idx = listeners.indexOf(callback);
    if (idx >= 0) {
      listeners.splice(idx, 1);
    }
  }

  function on(callback: ContourChangeListener): () => void {
    listeners.push(callback);
    return () => off(callback);
  }

  function normalizeUIDs(UIDs: string | string[]): string[] {
    if (Array.isArray(UIDs)) return UIDs;
    if (UIDs) return [UIDs];
    return [];
  }

  function emitChange(
    type: ContourChangeType,
    UIDs: string | string[],
    label?: ContourLabel,
    id?: ContourLabelItemId,
  ) {
    emit({
      type,
      UIDs: normalizeUIDs(UIDs),
      label,
      id,
    });
  }

  return { emit, on, off, emitChange };
});
